import { useEffect, useState } from 'react';
import { getAdapter } from '@/data/adapters';
import type { IStorageAdapter } from '@/data/adapters/types';

export function useStorageAdapter() {
  const [adapter, setAdapter] = useState<IStorageAdapter | null>(null);

  useEffect(() => {
    let isMounted = true;

    const initAdapter = async () => {
      try {
        const currentAdapter = await getAdapter();
        if (isMounted) {
          setAdapter(currentAdapter);
        }
      } catch (error) {
        // Silently handle errors in test environment
        if (isMounted && typeof window !== 'undefined') {
          console.error('Failed to initialize storage adapter:', error);
        }
      }
    };

    initAdapter();

    return () => {
      isMounted = false;
    };
  }, []);

  return adapter;
}
